import styled from "@emotion/styled";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { alpha, Box } from "@kaltura/mediaspace-shared-styled";
import { Typography } from "@kaltura/ds-react-components";

interface UploadProgressBarProps {
    loaded: number;
    total: number;
    ariaLabel: string;
}

const StyledContainer = styled("div")(({ theme }) => ({
    height: "100%",
    display: "flex",
    position: "relative",
    borderRadius: theme.kaltura.shape.roundness2,
    backgroundColor: alpha(theme.kaltura.palette.primary.main, 0.7),
    overflow: "hidden",
    color: theme.kaltura.palette.primary.contrastText,
}));

const StyledProgressBar = styled(Box)(({ theme }) => ({
    height: "100%",
    borderRadius: `${theme.kaltura.shape.roundness2}px 0 0 ${theme.kaltura.shape.roundness2}px`,
    backgroundColor: theme.kaltura.palette.primary.main,
}));

const StyledProgressTitle = styled("div")(({ theme }) => ({
    position: "absolute",
    display: "flex",
    width: "100%",
    height: "100%",
    flexDirection: "column",
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
}));

/**
 *  in place uploader progress bar
 */
export const UploadProgressBar = (props: UploadProgressBarProps) => {
    const { loaded, total, ariaLabel } = props;

    const progress = Math.round(Math.min(loaded / total, 1) * 100);

    return (
        <StyledContainer
            role="progressbar"
            aria-valuenow={progress}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={ariaLabel}
        >
            <StyledProgressBar style={{ width: `${progress || 0}%` }} />
            <StyledProgressTitle>
                <Typography variant={"h3"} component="div">{`${progress || 0}%`}</Typography>
                <Typography variant={"h5"} component="div">
                    {translate("Uploading...")}
                </Typography>
            </StyledProgressTitle>
        </StyledContainer>
    );
};
